import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-orientation-error',
  templateUrl: './orientation-error.component.html',
  styleUrls: ['./orientation-error.component.scss'],
  standalone: false
})
export class OrientationErrorComponent {
  @Input() showBrowserProblemLink: boolean = false;

}
